// Switch: on/off that takes effect at once (no form to submit), as a button with role="switch".
// Ported from the Humint Assistant's components/ui/switch.tsx.
import type { ComponentProps } from 'react';
import { cn } from './cn';

export interface SwitchProps extends Omit<ComponentProps<'button'>, 'onChange' | 'type'> {
  checked: boolean;
  onChange?: (checked: boolean) => void;
}

export function Switch({ checked, onChange, className, ...props }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange?.(!checked)}
      className={cn(
        'relative inline-flex h-5 w-9 flex-none cursor-pointer items-center rounded-full border transition-colors disabled:cursor-not-allowed disabled:opacity-50',
        checked ? 'border-accent bg-accent' : 'border-hairline-strong bg-surface',
        className,
      )}
      {...props}
    >
      <span
        className={cn(
          'inline-block size-3.5 rounded-full transition-transform',
          checked ? 'translate-x-[17px] bg-accent-ink' : 'translate-x-[2px] bg-ink-muted',
        )}
      />
    </button>
  );
}
